var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('window-header'),_c('nav',{staticStyle:{"justify-content":"space-between"}},[_c('button',{staticClass:"button button-fill",class:{ disabled: _vm.tabDisabled(_vm.activeTab - 1) },on:{"click":function($event){return _vm.$refs['main-tabs'].prevTab()}}},[_c('fa-icon',{attrs:{"icon":['fas', 'chevron-left']}}),_c('span',[_vm._v(_vm._s(_vm.$t("back")))])],1),(_vm.activeTab < 2)?_c('button',{staticClass:"button button-fill",class:{ disabled: _vm.tabDisabled(_vm.activeTab + 1) },on:{"click":function($event){return _vm.$refs['main-tabs'].nextTab()}}},[_c('span',[_vm._v(_vm._s(_vm.$t("next")))]),_c('fa-icon',{attrs:{"icon":['fas', 'chevron-right']}})],1):_vm._e(),(_vm.activeTab == 2)?_c('button',{staticClass:"button button-fill",class:{ disabled: !_vm.lineasSelected().length },on:{"click":_vm.finalizar}},[_c('span',[_vm._v("Finalizar")])]):_vm._e(),(_vm.activeTab == 2)?[_c('field',{staticStyle:{"top":"35px","left":"170px"},attrs:{"name":"total_lineas","widget":"float","readonly":"","dec":"2","label":"Total","width":"100px"}}),_c('field',{staticStyle:{"top":"35px","left":"280px"},attrs:{"name":"total_unidades","widget":"float","readonly":"","dec":"2","label":"Unidades","width":"100px"}}),_c('field',{staticStyle:{"top":"35px","left":"390px"},attrs:{"name":"total_peso","widget":"float","readonly":"","dec":"2","label":"Peso","width":"100px"}})]:_vm._e()],2),_c('section',[_c('article',{staticStyle:{"height":"436px","width":"675px"}},[_c('r-tabs',{ref:"main-tabs",staticStyle:{"top":"0px","left":"0px","height":"435px"},attrs:{"wt":_vm.formData.wt,"buttons":['1. Filtrar', '2. Condicionales', '3. Líneas'],"classButton":function (i) { return ({ disabled: _vm.tabDisabled(i) }); },"styleButton":'width:33%;'},on:{"active":_vm.onActiveTab}},[_c('div',{staticClass:"tab"},[_c('fieldset',{staticStyle:{"position":"relative","left":"80px","top":"80px","width":"480px","height":"200px"},attrs:{"model":"albaran_cliente"}},[_c('legend',[_vm._v("Seleccione filtros")]),_c('field',{staticStyle:{"top":"47px","left":"70px"},attrs:{"name":"cliente_id","label":"Cliente","widget":"m2o","labelProp":"nombre_comercial","width":"320px"}}),_c('field',{staticStyle:{"top":"90px","left":"70px"},attrs:{"name":"condicionales","widget":"checkbox","label":"Condicionales","reverse":"","inline-label":""}}),(_vm.showWt)?_c('field',{staticStyle:{"top":"110px","left":"70px"},attrs:{"name":"notas_condicionales","widget":"checkbox","label":"Prop. de Condicionales","reverse":"","inline-label":""}}):_vm._e(),_c('field',{staticStyle:{"top":"106px","right":"50px"},attrs:{"name":"desde","type":"date","label":"Desde","width":"100px","inline-label":""}}),_c('field',{staticStyle:{"top":"126px","right":"50px"},attrs:{"name":"hasta","type":"date","label":"Hasta","width":"100px","inline-label":""}})],1)]),_c('div',{staticClass:"tab"},[_c('field',{ref:"documentos_pendientes",staticStyle:{"top":"30px","left":"4px","width":"653px"},attrs:{"name":"documentos_pendientes","widget":"handsontable","height":360,"width":650,"minRows":18,"customprop":"docs_customprop","columns":[
              {
                name: 'sel',
                header: 'Sel.',
                widget: 'checkbox',
                help: 'Seleccionado',
              },
              { name: 'ndoc', header: 'NºDocumento', readOnly: true },
              {
                name: 'cliente_id',
                header: 'Cliente',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre_comercial',
                showCode: true,
              },
              {
                name: 'fecha',
                type: 'date2',
                header: 'Fecha',
                readOnly: true,
              },
              {
                name: 'total',
                header: 'Total',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'divisa_id',
                header: 'Divisa',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre',
                showCode: true,
              },
              {
                name: 'cambio',
                header: 'Cambio',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              } ]}}),_c('span',{staticStyle:{"position":"absolute","top":"5px","left":"5px"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Seleccionar todos'),expression:"'Seleccionar todos'"}],attrs:{"name":"sel_all_docs"},on:{"click":_vm.sellAllDocs}},[_c('fa-icon',{attrs:{"icon":['far', 'check-square']}})],1),_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Desseleccionar todos'),expression:"'Desseleccionar todos'"}],attrs:{"name":"dessel_all_docs"},on:{"click":_vm.desselAllDocs}},[_c('fa-icon',{attrs:{"icon":['far', 'square']}})],1)])],1),_c('div',{staticClass:"tab"},[_c('field',{ref:"lineas_pendientes",staticStyle:{"top":"5px","left":"4px","width":"653px"},attrs:{"name":"lineas_pendientes","widget":"handsontable","label":"Líneas","height":380,"width":650,"minRows":18,"customprop":"lines_customprop","htSettings":{ columnSorting: true },"columns":[
              {
                name: 'sel',
                header: 'Sel.',
                widget: 'checkbox',
                help: 'Seleccionado',
              },
              {
                name: 'ean13',
                header: '|||||||||',
                help: 'Código de barras del artículo',
                readOnly: true,
              },
              {
                name: 'articulo_id',
                header: 'Artículo',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                noOpen: true,
                fields: [
                  { name: 'thumbnail', fields: ['imagen'] },
                  'tarifa1',
                  'tarifa2',
                  'tarifa3',
                  'tarifa4',
                  'tarifa5',
                  'tarifa6',
                  'tarifa7',
                  'tarifa8',
                  'tarifa9',
                  'tarifa10' ],
                readOnly: true,
              },
              { name: 'descripcion', header: 'Descripción', readOnly: true },
              {
                name: 'modelo_id',
                header: 'Modelo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                readOnly: true,
              },
              //{name:'familia_id',header:'Familia', type:'m2o', primary:'codigo', label:'codigo', readOnly:true},
              { name: 'nota', header: 'Nota', readOnly: true },
              {
                name: 'tt',
                header: 'T',
                type: 'select',
                options: ['A', 'R'],
                readOnly: true,
              },
              {
                name: 'almacen_id',
                header: 'Almacén',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                readOnly: true,
              },
              {
                name: 'unidades_pendientes',
                header: 'Unid. pendientes',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'peso_pendiente',
                header: 'Peso pendiente',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },
              {
                name: 'unidades',
                header: 'Unid.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'peso',
                header: 'Peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },

              {
                name: 'taqueria_ids',
                header: 'Taquería',
                type: 'm2m',
                primary: 'codigo',
                image: 'thumbnail.imagen',
                fields: ['precio_coste'],
                label: 'codigo',
                filter: function () { return ['seccion_id', '=', 'PCK']; },
                readOnly: true,
              },
              {
                name: 'taqueria_precio',
                header: 'Taq.(€)',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true,
              },
              {
                name: 'v',
                header: 'V',
                type: 'select',
                options: ['U', 'P'],
                readOnly: true,
              },
              { name: 'm', header: 'M', type: 'checkbox', readOnly: true },
              { name: 'r', header: 'R', type: 'checkbox', readOnly: true },
              {
                name: 'precio_coste',
                header: 'P. Coste',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'tt2',
                header: 'T',
                type: 'select',
                options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                readOnly: true,
              },
              {
                name: 'precio',
                header: 'Precio',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true,
              },
              {
                name: 'descuentos',
                header: 'Dtos.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                sufix: '%',
                readOnly: true,
              },
              {
                name: 'descuento_peso',
                header: 'Dto./peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                sufix: '%',
                readOnly: true,
              },
              {
                name: 'totallinea',
                header: 'Total Línea',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true,
              },
              { name: 'm2', header: 'M', type: 'checkbox', readOnly: true },
              { name: 'c2', header: 'C', type: 'checkbox', readOnly: true },
              { name: 'p', header: 'P', type: 'checkbox', readOnly: true },
              { name: 'u', header: 'U', type: 'checkbox', readOnly: true },
              {
                name: 'com',
                header: 'Com.',
                type: 'm2o',
                label: 'codigo',
                primary: 'codigo',
                emptyOnError: true,
                readOnly: true,
              },
              {
                name: 'c',
                header: 'C.',
                type: 'select',
                options: ['D', 'I'],
                readOnly: true,
              },
              {
                name: 'margen',
                header: '%',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                sufix: '%',
                readOnly: true,
              },
              {
                name: 'pventa',
                header: 'PVP',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true,
              },
              { name: 'e', header: 'E', type: 'checkbox', readOnly: true } ]}})],1)])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }